import { Component, Input, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { DisclaimerModalComponent } from './disclaimer-modal/disclaimer-modal.component';

@Component({
    selector: 'app-footer',
    templateUrl: 'footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  private readonly modalController = inject(ModalController);

  @Input() pageType: string;

  async presentModal() {
    const modal = await this.modalController.create({
      component: DisclaimerModalComponent,
      cssClass: 'disclaimer-modal',
    });
    await modal.present();
  }
}
